import { useRecordViewCounts } from './useRecordViewCounts';

/** Перегляди одного запису (бічна частина статті прототипу v4 «Переглядів: N»): число, коли лічильники типу відомі, інакше undefined. */
export function useRecordViewCount(ws: string, rt: string, id: string): number | undefined {
  const { counts, known } = useRecordViewCounts(ws, rt);
  return known ? counts.get(id) ?? 0 : undefined;
}
